import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";

interface DeleteScheduledModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
  entityType?: "note" | "moment";
}

export function DeleteScheduledModal({
  isOpen,
  onClose,
  onConfirm,
  loading = false,
}: DeleteScheduledModalProps) {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-sm rounded-2xl p-6" hideCloseButton>
        <DialogHeader className="space-y-2">
          <DialogTitle className="text-lg font-semibold">
            Are you sure you want to delete?
          </DialogTitle>
          <DialogDescription className="text-sm text-gray-500">
            This will delete all content
          </DialogDescription>
        </DialogHeader>

        <div className="mt-4 flex gap-3">
          <Button
            variant="outline"
            onClick={onClose}
            disabled={loading}
            className="flex-1 rounded-xl"
          >
            Cancel
          </Button>
          <Button
            onClick={onConfirm}
            disabled={loading}
            className="flex-1 rounded-xl bg-black text-white hover:bg-gray-800"
          >
            {loading ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Deleting...
              </>
            ) : (
              "Delete"
            )}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
